__webpack_require__.p = "https://appupgrade.truckscience.com/";